import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import {GelContentContainer, HeroBlock} from "cw-styleguide-react";

class ProvidersManageView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.providers.manage.title')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.t('view.providers.manage.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          {this.props.t('view.providers.manage.introduction')}
        </HeroBlock>
      </Fragment>
    );
  }
}

export default withTranslation('local')(ProvidersManageView);
